import { useEffect, useRef, useState } from "react";
import { FileText, User } from "react-feather";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllCharges } from "../../api/finance/addChargesApi";
import {
  checkChargeTypeAlredyAvilable,
  saveChargeType,
  updateChargeType,
} from "../../api/finance/chargeTypeApi";
import { getBulkDropdownData } from "../../api/keyvalue";
import { formatFromJsonDate } from "../../dateConfig";
import useUserCompany from "../../hooks/useUserCompany";
import InfoList from "../InfoList";
import Button from "../input/Button";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import LoadingSpinner from "../LoadingSpinner";
import ItemTaxForm from "../master/deduction/ItemTaxForm";
import Tab from "../Tab";
import { chargeTypeFormValidator } from "../validations/ChargeType";

function ChargeTypeAdd({ editMode, handleDrawerClose, currentValues }) {
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(1);
  const taxRef = useRef();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const nextButtonHandler = () => {
    if (tab < 2) {
      const chargeTypeErrors = chargeTypeFormValidator({
        chtCharge: chargeType,
        chtPercentage: precentage,
        chtEv: ev,
        chtInvoice: invoice,
        chtTransporters: transporters,
        chtCompany: company,
        chtStatus: status,
        chtActive: active,
        chtItemCatogery: itemCategory,
        chtNegotiation: negotiation,
        chtQtyCharge: qtycharge,


      });

      if (Object.keys(chargeTypeErrors).length > 0) {
        setCurrentErrors(chargeTypeErrors);
        toast.error("Please Fill the required fields", {
          autoClose: 5000,
          containerId: "Main",
        });
        // setIsSubmitLoading(false);
      } else {
        setCurrentErrors({});
        setTab(tab + 1);
      }
    }
  };

  const userCompany = useUserCompany();

  //Form Fields
  const [chargeCode, setChargeCode] = useState("");
  const [chargeReferance, setChargeReferance] = useState("");
  const [chargeType, setChargeType] = useState("");
  const [chargeDescription, setChargeDescription] = useState("");
  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);
  const [negotiation, setNegotiation] = useState(1);
  const [precentage, setPrecentage] = useState(2);
  const [ev, setEv] = useState(2);
  const [invoice, setInvoice] = useState(2);
  const [transporters,setTransporters]=useState(1);
  const [taxData, setTaxData] = useState([]);
  const [qtycharge, setQtycharge] = useState(1);

  // dropdown data

  const [statusTypeOptions, setStatusTypeOptions] = useState([]);
  const [activeTypeOptions, setActiveTypeOptions] = useState([]);
  const [yesnoOptions, setYesnoOptions] = useState([]);
  const [negotiationOptions, setNegotiationOptions] = useState([]);
  const [currentErrors, setCurrentErrors] = useState({});
  const [itemCategory, setItemCategory] = useState(9);
  const [itemCategoryOptions, setItemCategoryOptions] = useState([]);
  const [chargeOpt, setChargeOpt] = useState([]);
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );

  const [qtychargeOptions, setQtyChargeOptions] = useState([]);
  const negotiationValue = negotiationOptions?.find(
    (opt) => opt.text === "None"
  )?.value;

  const [filteredChargeTypes, setFilteredChargeTypes] = useState([]);
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  useEffect(() => {
    if (editMode && currentValues) {
      setChargeCode(currentValues?.chtCode);
      setChargeReferance(currentValues?.chtReferance);
      setChargeType(currentValues?.chtCharge);
      setChargeDescription(currentValues?.chtDescription);
      setStatus(currentValues?.chtStatus);
      setActive(currentValues?.chtActive);
      setPrecentage(currentValues?.chtPercentage ? 1 : 2);
      setEv(currentValues?.chtEv ? 1 : 2);
      setInvoice(currentValues?.chtInvoice ? 1 : 2);
      setTransporters(currentValues?.chtTransporters ? 1 : 2);
      setItemCategory(currentValues?.chtItemCatogery);
      setNegotiation(currentValues?.chtNegotiation);
      setQtycharge(currentValues?.chtQtyCharge || 1);
        
      setTaxData(currentValues?.chargeTypeTaxes);
    }
  }, [editMode, currentValues]);
  useEffect(() => {
    (async () => {
      setIsDropdownLoading(true);

      const charges = await getAllCharges();
      setChargeOpt(charges);

      const {
        status: statusTypeData,
        active: activeTypeData,
        yesno: yesNoData,
        item_type: itemCategory,
        negotiation_charge: negotiationOptions,
        charge_negotiation_unit: charge_negotiation_unit,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
        { key: "yesno" },
        { key: "item_type" },
        { key: "negotiation_charge" },
        { key: "charge_negotiation_unit" },
      ]);
      setStatusTypeOptions(statusTypeData);
      setActiveTypeOptions(activeTypeData);
      setYesnoOptions(yesNoData);
      setItemCategoryOptions(itemCategory);
      setNegotiationOptions(negotiationOptions);
     // setNegotiationOptions(negotiationOptions);
      setQtyChargeOptions(charge_negotiation_unit);

      setIsDropdownLoading(false);
    })();
  }, []);

  console.log("charge type opt", chargeOpt);

  const resetForm = () => {
    setChargeCode("");
    setChargeReferance("");
    setChargeType("");
    setChargeDescription("");
    setStatus(2);
    setActive(1);
    setPrecentage(2);
    setEv(2);
    setInvoice(2);
    setTransporters(1);
    setNegotiation(1);
    setQtycharge(1);

    // setItemCategory(9);
    taxRef.current.resetForm();
  };
  const handleFormSubmit = async () => {
    setIsSubmitLoading(true);
    let isAvailable = false;
    if (!editMode) {
      isAvailable = await checkChargeTypeAlredyAvilable({
        chargeType: chargeType,
      });
    }
    if (isAvailable) {
      toast.warn("Charge Type Is Already Avilable", {
        autoClose: 5000,
        containerId: "Main",
      });
      setCurrentErrors({ chtCharge: "Charge Type Is Already Avilable" });
      setIsSubmitLoading(false);
      return;
    } else {
      setCurrentErrors({});

      const chargeTypeErrors = chargeTypeFormValidator({
        chtCharge: chargeType,
        chtPercentage: precentage,
        chtEv: ev,
        chtInvoice: invoice,
        chtTransporters: transporters,
        chtCompany: company,
        chtStatus: status,
        chtActive: active,
        chtItemCatogery: itemCategory,
        chtNegotiation: negotiation,
        chtQtyCharge: qtycharge,

      
      });

      if (Object.keys(chargeTypeErrors).length > 0) {
        setCurrentErrors(chargeTypeErrors);
        toast.error("Please Fill the required fields", {
          autoClose: 5000,
          containerId: "Main",
        });

        setIsSubmitLoading(false);
        console.log("Validation Errors:", chargeTypeErrors);
        return;
      } else {
        setCurrentErrors({});
      }


      if (!editMode) {
        // setGridData(taxRef.current.getData());
        const data = {
          chtReferance: chargeReferance,
          chtCharge: chargeType,
          chtDescription: chargeDescription,
          chtPercentage: precentage === 1 ? true : false,
          chtEv: ev === 1 ? true : false,
          chtInvoice: invoice === 1 ? true : false,
          chtTransporters: transporters === 1 ? true : false,
          chtCompany: company,
          chtStatus: status,
          chtActive: active,
          chtItemCatogery: itemCategory,
          chtNegotiation: negotiation,
          chtQtyCharge: qtycharge,
          author: user.username,
          chargeTypeTaxes: taxRef.current?.getData?.()
            ?.selectedTaxes?.map((item) => ({
              chtTax: item.itemTax,
              chtReferance: item.itemReference,
              chtDefault: item.chtDefault === 1 ? true : false,
              chtCustomer: item.chtDefault === 1 ? null : item.chtCustomer,
              chtStakeType: item.chtDefault === 1 ? null : item.chtStakeType,
              chtStatus: item.status,
              chtActive: item.active,
              author: user.username,
              chtOpeType: 19,
            })) || [],
        };

        const response = await saveChargeType(data);

        if (response?.status === 201) {
          toast.success(response.data, {
            autoClose: 5000,
            containerId: "Main",
          });
          resetForm();
          handleDrawerClose();
        } else {
          toast.error("Error occurred while saving...", {
            autoClose: 5000,
            containerId: "Main",
          });
        }
      } else {
        const data = {
          chtId: currentValues?.chtId,
          chtReferance: chargeReferance,
          chtCharge: chargeType,
          chtDescription: chargeDescription,
          chtPercentage: precentage === 1 ? true : false,
          chtEv: ev === 1 ? true : false,
          chtInvoice: invoice === 1 ? true : false,
          chtTransporters: transporters === 1 ? true : false,
          chtStatus: status,
          chtActive: active,
          chtItemCatogery: itemCategory,
          chtNegotiation: negotiation,
          chtQtyCharge: qtycharge,
          author: user.username,
          chargeTypeTaxes: taxRef.current?.getData?.()
            ?.selectedTaxes?.map((item) => ({
              chtId: item.chtId,
              chtTax: item.itemTax,
              chtReferance: item.itemReference,
              chtDefault: item.chtDefault === 1 ? true : false,
              chtCustomer: item.chtDefault === 1 ? null : item.chtCustomer,
              chtStakeType: item.chtDefault === 1 ? null : item.chtStakeType,
              chtStatus: item.status,
              chtActive: item.active,
              author: user.username,
              chtOpeType: 19,
            })) || [],
        };

        const response = await updateChargeType(data);

        if (response?.status === 200) {
          toast.success(response.data, {
            autoClose: 5000,
            containerId: "Main",
          });
          resetForm();
          handleDrawerClose();
        } else {
          toast.error("Error occurred while updating...", {
            autoClose: 5000,
            containerId: "Main",
          });
        }
      }
    }

    setIsSubmitLoading(false);
  };

  return (
    <div style={{ width: "60vw" }}>
      <div className="ui top attached tabular menu">
        <Tab
          Icon={LiaFileInvoiceDollarSolid}
          onClick={() => {
            setTab(1);
          }}
          active={tab === 1}
          label="Charge Types"
        />
        <Tab
          Icon={FileText}
          onClick={() => {
            setTab(2);
          }}
          active={tab === 2}
          label="Charge Tax"
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        {isDropdownLoading ? (
          <LoadingSpinner />
        ) : (
          <form className="ui form">
            <div className="ui segment">
              <h4 className="ui dividing header">Charge Types</h4>
              <div className="field">
                <div className="two fields">
                  <Input
                    label="Charge code"
                    field="cht_code"
                    type="text"
                    name="cht_code"
                    value={chargeCode}
                    onChange={(e) => {
                      setChargeCode(e.target.value);
                    }}
                    disabled={true}
                  />
                  <Input
                    label="Charge Referance"
                    type="text"
                    name="cht_referance"
                    value={chargeReferance}
                    onChange={(e) => {
                      setChargeReferance(e.target.value);
                    }}
                  />
                </div>
                <div className="two fields">
                  <div
                    className="field"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Input
                      required={true}
                      label="Charge Type"
                      type="text"
                      error={currentErrors.chtCharge}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { chtCharge: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      name="cht_charge"
                      disabled={editMode}
                      value={chargeType}
                      onChange={(e) => {
                        const value = e.target.value;
                        setChargeType(value);

                        if (value.trim() === "") {
                          setFilteredChargeTypes([]);
                          return;
                        }

                        const filtered = chargeOpt.filter((opt) =>
                          opt.text.toLowerCase().includes(value.toLowerCase())
                        );
                        setFilteredChargeTypes(filtered);
                      }}
                    />
                    {filteredChargeTypes.length > 0 && (
                      <div
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                          marginTop: "2px",
                          padding: "5px",
                          maxHeight: "100px",
                          overflowY: "auto",
                          fontSize: "14px",
                          color: "#666",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            marginBottom: "5px",
                          }}
                        >
                          Already Added charge types Here:
                        </div>
                        {filteredChargeTypes.map((item) => (
                          <div key={item.id}>{item.text}</div>
                        ))}
                      </div>
                    )}
                  </div>

                  <Input
                    label="Charge Discription"
                    type="text"
                    name="cht_description"
                    value={chargeDescription}
                    onChange={(e) => {
                      setChargeDescription(e.target.value);
                    }}
                  />
                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    label="Percentage"
                    placeholder="Precentage"
                    error={currentErrors.chtPercentage}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtPercentage: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    options={yesnoOptions}
                    value={precentage}
                    style={{ height: "20px" }}
                    onChange={(e, data) => {
                      setPrecentage(data.value);
                    }}
                  />
                  <Dropdown
                    required={true}
                    label="EV"
                    placeholder="EV"
                    error={currentErrors.chtEv}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtEv: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    style={{ height: "20px" }}
                    options={yesnoOptions}
                    value={ev}
                    onChange={(e, data) => {
                      setEv(data.value);
                    }}
                  />
                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    label="Invoice"
                    placeholder="Invoice"
                    error={currentErrors.chtInvoice}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtInvoice: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    style={{ height: "20px" }}
                    options={yesnoOptions}
                    value={invoice}
                    onChange={(e, data) => {
                      setInvoice(data.value);
                    }}
                  />

                  <Dropdown
                    required={true}
                    label="Transporter"
                    placeholder="Transporter"
                    error={currentErrors.chtTransporters}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtTransporters: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    style={{ height: "20px" }}
                    options={yesnoOptions}
                    value={transporters}
                    onChange={(e, data) => {
                      setTransporters(data.value);
                    }}
                  />

                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    label="Item Category"
                    placeholder="Item Category"
                    error={currentErrors.chtItemCatogery}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtItemCatogery: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    style={{ height: "20px" }}
                    options={itemCategoryOptions}
                    value={itemCategory}
                    onChange={(e, data) => {
                      setItemCategory(data.value);
                    }}
                  />
                  <Dropdown
                    required={true}
                    label="Negotiation Type"
                    placeholder="Negotiation Type"
                    error={currentErrors.chtNegotiation}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtNegotiation: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    style={{ height: "20px" }}
                    options={negotiationOptions}
                    value={negotiation}
                    onChange={(e, data) => {
                      setNegotiation(data.value);
                      if (data.value === negotiationValue) {  
                        setQtycharge(1);
                      }
                    }}
                  />
                </div>
                 <div className="two fields"> 
                  {negotiation !== negotiationValue && ( 

                    <Dropdown
                    required={true}
                    label="Qty/Charge"
                    placeholder="Qty/Charge"
                    error={currentErrors.chtQtyCharge}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtQtyCharge: _, ...rest } = prevState; 
                        return rest;
                        })
                    }
                    style={{ height: "20px" }}
                    options={qtychargeOptions}
                    value={qtycharge}
                    onChange={(e, data) => {
                      setQtycharge(data.value);
                    }}
                    
                    />
                  )}
                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    label="Status"
                    placeholder="Status"
                    error={currentErrors.chtStatus}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtStatus: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    options={statusTypeOptions}
                    value={status}
                    style={{ height: "20px" }}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    required={true}
                    label="Active"
                    placeholder="Active"
                    error={currentErrors.chtActive}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { chtActive: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    style={{ height: "20px" }}
                    options={activeTypeOptions}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <ItemTaxForm
          ref={taxRef}
          editMode={editMode}
          opeTyped={19}
          currentValues={taxData}
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {tab > 1 && (
            <Button
              template="back"
              tab={tab - 1}
              onClick={() => setTab(tab - 1)}
            />
          )}
          {tab < 2 && (
            <Button template="next" tab={tab + 1} onClick={nextButtonHandler} />
          )}
          {editMode ? (
            <Button
              type="submit"
              template="create"
              isLoading={isSubmitLoading}
              create={!editMode}
              editMode={editMode}
              onClick={handleFormSubmit}
            />
          ) : tab === 2 ? (
            <Button
              type="submit"
              template="create"
              isLoading={isSubmitLoading}
              create={!editMode}
              editMode={editMode}
              onClick={handleFormSubmit}
            />
          ) : (
            ""
          )}
        </div>
      </div>

      {editMode && (
        <InfoList
          title="User Information"
          content={[
            {
              title: "Created By",
              value: currentValues.createdBy ? currentValues.createdBy : "N/A",
            },
            {
              title: "Created Date",
              value: currentValues.createdDate
                ? formatFromJsonDate(currentValues.createdDate)
                : "N/A",
            },
            {
              title: "Last Modified By",
              value: currentValues.lastModifiedBy
                ? currentValues.lastModifiedBy
                : "N/A",
            },
            {
              title: "Last Modified Date",
              value: currentValues.lastModifiedDate
                ? formatFromJsonDate(currentValues.lastModifiedDate)
                : "N/A",
            },
          ]}
          Icon={User}
        />
      )}
    </div>
  );
}
export default ChargeTypeAdd;


